"use client";

import { useState } from "react";
import { NavigationTabs } from "@/components/common/navigationTabs";
import { TableContainer } from "@/components/common/TableContainer";
import DeliveryLocations from "@/components/settings/DeliveryLocations";
import Pickup from "@/components/settings/Pickup";

const locationsTabs = [
  { label: "Delivery Locations", value: "delivery" },
  { label: "Pickup Locations", value: "pickup" },
];

const LocationsPage = () => {
  const [activeTab, setActiveTab] = useState<string>("delivery");

  const renderTabContent = () => {
    switch (activeTab) {
      case "delivery":
        return <DeliveryLocations />;
      case "pickup":
        return <Pickup />;
      default:
        return <DeliveryLocations />;
    }
  };

  return (
    <div className="space-y-4">
      <TableContainer
        navigationTabs={
          <NavigationTabs
            tabs={locationsTabs.map((tab) => ({
              label: tab.label,
              onClick: () => setActiveTab(tab.value),
              isActive: activeTab === tab.value,
            }))}
            hasBackButton={false}
          />
        }
      >
        {renderTabContent()}
      </TableContainer>
    </div>
  );
};

export default LocationsPage;
